export enum PolicyComponentCreationStepTypes {
    COMPONENT_DETAILS = "COMPONENT_DETAILS",
    TRIGGER_CONFIGURATION = "TRIGGER_CONFIGURATION"
} 